// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aJ3e","input":"styles_input__2FX79"};